type InboxV2BoardsChangedListener = () => void;

const boardsChangedListeners = new Set<InboxV2BoardsChangedListener>();

export function notifyInboxV2BoardsChanged() {
  for (const listener of Array.from(boardsChangedListeners)) {
    listener();
  }
}

export function subscribeInboxV2BoardsChanged(
  listener: InboxV2BoardsChangedListener
) {
  boardsChangedListeners.add(listener);

  return () => {
    boardsChangedListeners.delete(listener);
  };
}

export function resetInboxV2BoardEventsForTests() {
  boardsChangedListeners.clear();
}
